import styled from "styled-components";
import Video from "../Video/Video";

export const ContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 48%;
  flex: 1;
`;

export const LeftContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 223.68px;
  gap: 12px;

  @media (max-width: 768px) {
    min-width: unset;
  }
`;

export const SectionLabel = styled.span`
  color: var(--color-text-muted);
  font-family: var(--font-family-primary);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
`;

export const ArrowContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 5;
  transform: translate(-50%, -50%);
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: rgba(22, 32, 52, 0.9);
  border: 1px solid rgba(var(--color-brand-300-rgb), 0.15);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow:
    0 4px 14px rgba(0, 0, 0, 0.3),
    0 0 0 4px rgba(var(--color-brand-400-rgb), 0.05);

  @media (max-width: 768px) {
    width: 32px;
    height: 32px;
  }

  @media (max-width: 350px) {
    width: 28px;
    height: 28px;
  }
`;

export const StyledVideo = styled(Video)`
  height: 100%;
  width: 100%;
  aspect-ratio: unset;
  border-radius: 18px;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const UploadVideoContainer = styled.div`
  position: relative;
  height: 280px;
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1.5px dashed white;
  background:
    radial-gradient(
      120% 60% at 30% -10%,
      rgba(var(--color-brand-300-rgb), 0.32) 0%,
      rgba(var(--color-brand-400-rgb), 0.28) 55%,
      rgba(var(--color-brand-600-rgb), 0.32) 100%
    ),
    linear-gradient(
      180deg,
      rgba(var(--color-brand-500-rgb), 0.22) 0%,
      rgba(var(--color-brand-700-rgb), 0.36) 100%
    );

  box-shadow:
    0 12px 26px rgba(var(--color-brand-700-rgb), 0.28),
    inset 0 1px 0 rgba(255, 255, 255, 0.32),
    inset 0 -4px 12px rgba(var(--color-brand-800-rgb), 0.32);

  [data-theme="dark"] & {
    box-shadow:
      0 8px 18px rgba(0, 0, 0, 0.5),
      inset 0 -4px 12px rgba(0, 0, 0, 0.32);
  }

  @media (max-width: 768px) {
    height: 240px;
  }
`;

export const UploadVideoButton = styled.button`
  position: relative;
  z-index: 2;
  height: 100%;
  width: 100%;
  padding: 24px 18px;
  border: none;
  border-radius: 20px;
  background: transparent;
  cursor: pointer;
  outline: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: background 200ms var(--ease-snappy);

  &:hover {
    background: rgba(var(--color-brand-300-rgb), 0.12);
  }

  svg {
    width: 40px;
    height: 40px;

    path {
      stroke: white;
    }
  }
`;

export const UploadVideoTitle = styled.p`
  margin-top: 14px;
  color: var(--glass-text-on-pill);
  font-family: var(--font-family-primary);
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.005em;
`;

export const UploadVideoDesc = styled.p`
  margin-top: 6px;
  max-width: 200px;
  color: var(--glass-text-on-pill);
  opacity: 0.7;
  text-align: center;
  font-family: var(--font-family-primary);
  font-size: 12px;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.005em;
`;

export const DeleteButton = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border-radius: 50%;
  border: 1px solid var(--glass-edge-soft);
  background: radial-gradient(
    130% 100% at 30% 15%,
    rgba(var(--glass-white-rgb), 0.82) 0%,
    rgba(var(--glass-white-rgb), 0.54) 45%,
    rgba(var(--glass-pale-rgb), 0.42) 100%
  );
  backdrop-filter: blur(18px) saturate(180%);
  -webkit-backdrop-filter: blur(18px) saturate(180%);
  box-shadow:
    0 6px 14px rgba(var(--color-brand-500-rgb), 0.16),
    inset 0 1px 0 rgba(255, 255, 255, 0.95),
    inset 0 -3px 8px rgba(var(--color-brand-200-rgb), 0.22);
  color: var(--color-brand-700);
  cursor: pointer;
  transition:
    transform 200ms var(--ease-snappy),
    border-color 200ms var(--ease-snappy);

  [data-theme="dark"] & {
    border-color: transparent;
    background: var(--color-surface-3);
    box-shadow:
      0 4px 10px rgba(0, 0, 0, 0.45),
      inset 0 -2px 6px rgba(var(--color-brand-700-rgb), 0.16);
  }

  [data-theme="dark"] & svg path {
    stroke: var(--color-text-strong);
  }

  svg {
    width: 18px;
    height: 18px;
    position: relative;
    z-index: 1;
    path {
      stroke: var(--color-brand-700);
    }
  }

  &:hover {
    transform: translateY(-1px) scale(1.04);
    border-color: rgba(var(--color-brand-400-rgb), 0.5);
  }
`;
